import { graphql } from '@/generated/gql';

export const DELETE_SAVING_MUTATION = graphql(/* GraphQL */ `
  mutation DeleteSaving($id: ID!) {
    deleteSaving(id: $id)
  }
`);
